import React from 'react';
import { Actions, StyledHBButton } from './HBBanner.styles';
import { buttonThemes } from '../HBButton/HBButton.styles';
import type { TButtonSize } from '../HBButton/HBButton.types';
import { BannerActionsBaseProps, IBannerAction } from './HBBanner.types';

interface Props extends BannerActionsBaseProps {
    testId: string;
    align: 'start' | 'end';
    actionsSize: TButtonSize;
    className?: string;
}

const BannerActions = ({
    secondaryAction,
    testId,
    primaryAction,
    actionsTheme,
    primaryActionTheme,
    actionsSize,
    align,
    className
}: Props) => {
    if (!primaryAction) {
        return null;
    }

    const commonActionProps: Pick<BannerActionProps, 'size' | 'isLink'> = {
        size: actionsSize,
        isLink: actionsTheme === 'button-link'
    };

    return (
        <Actions align={align} className={className}>
            {secondaryAction && (
                <BannerAction
                    action={secondaryAction}
                    buttonTheme="secondary-invisible-secondary"
                    testId={testId ? `${testId}-secondary-button` : undefined}
                    {...commonActionProps}
                />
            )}

            <BannerAction
                action={primaryAction}
                buttonTheme={primaryActionTheme}
                testId={testId ? `${testId}-primary-button` : undefined}
                {...commonActionProps}
            />
        </Actions>
    );
};

export default BannerActions;

export interface BannerActionProps {
    testId: string;
    action: IBannerAction;
    buttonTheme?: keyof typeof buttonThemes;
    size?: TButtonSize;
    isLink?: boolean;
}

const BannerAction = ({
    action: { text, ...action },
    buttonTheme,
    testId,
    size = 'xs',
    isLink = false
}: BannerActionProps) => {
    return (
        <StyledHBButton
            isLink={isLink}
            size={size}
            buttonTheme={buttonTheme}
            testId={testId}
            {...action}
        >
            {text}
        </StyledHBButton>
    );
};
